import React from 'react';
import * as d3 from 'd3';
import { useD3 } from '../hooks/useD3';
import { decodeOtherLanguage, isVideo, lightenHex, setSessionValidity } from '../util/helpers/Helpers';
import QRCode from "react-qr-code";
import Barcode from 'react-barcode';
import moment from 'moment';
import { BEIN_CAMPAIGN, REESES_CAMPAIGN } from '../util/config/Constants';
// import { default as Fade } from 'react-fade'

function SpinWheel({ data, selection, selectedOffer, compData, offerData, code, offerCallback, showCheckout }) {

    let offerViewed = localStorage.getItem(`${compData.id}-offerViewed`);
    // offerViewed = false;

    let onSpinComplete = () => {
        offerCallback(true);
    };

    let toggleMute = () => {
      const video = document.getElementById("suspense-video");
      const muteBtn = document.getElementById("mute-button");
      if (video.muted) {
          video.muted = false;
          muteBtn.src = 'https://benchvote-media-assets.s3.ap-southeast-2.amazonaws.com/assorted/reeses/volume_up.png';
      } else {
          video.muted = true;
          muteBtn.src = 'https://benchvote-media-assets.s3.ap-southeast-2.amazonaws.com/assorted/reeses/volume_off.png';
      }
    };

    const ref = useD3(
        (div) => {

            let numberOfRotations = 8;
            let totalRotationAngle = numberOfRotations * 360;

            // default to 2 if any issue in selection
            let wheelSpinSpeed = 12;

            let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            vw = vw * 0.92;

            if (vw > 700) {
                vw = 700;
            }

            console.log("vw--", vw);

            let spinWheelLogoWidth = '62px';
            let spinWheelLogoX = '-31';
            let spinWheelLogoy = '-31';
            let spinWheelCenterRadius = 47;
            let spinWheelTextSize = '17px';
            let wheelTextPadding = 30;
            let pieStrokeWidth = 6;
            let borderRadiusExtra = 10;
            let borderStrokeWidth = 30;
            let padding = { top: 20, right: 43, bottom: 10, left: 18 };

            let wheelOuterColorGrad1 = '#f7ba00';
            if (compData.randomizerConfigs.spinWheelOuterColour
              && compData.randomizerConfigs.spinWheelOuterColour !== '') {
                wheelOuterColorGrad1 = compData.randomizerConfigs.spinWheelOuterColour;
              }

            // let wheelOuterColorGrad2 = '#fad8af';
            let wheelOuterColorGrad2 = lightenHex(wheelOuterColorGrad1, 40);

            let arrowColor = "#DF2422";
            if (compData.randomizerConfigs.spinWheelPointerColour
              && compData.randomizerConfigs.spinWheelPointerColour !== '') {
                arrowColor = compData.randomizerConfigs.spinWheelPointerColour;
              }


            if (vw <= 500) {
                spinWheelLogoWidth = '28px';
                spinWheelLogoX = spinWheelLogoy = '-14';
                spinWheelCenterRadius = 27;
                spinWheelTextSize = '12px';
                wheelTextPadding = 10;
                pieStrokeWidth = 1.5;
                borderRadiusExtra = 3;
                borderStrokeWidth = 4;
                padding = { top: 20, right: 9, bottom: 10, left: 9 };
            }

            let w = vw,
                h = vw,
                r = Math.min(w - padding.left - padding.right, h - padding.top - padding.bottom) / 2,
                rotation = 0,
                oldrotation = 0,
                picked = 100000,
                oldpick = [],
                color = d3.scale.category20();//category20c()


            let chartWidth = w + padding.left + padding.right;
            let chartHolderX = w / 2 + padding.left;
            let arrowX = w + padding.left + padding.right - 40;
            let arrowDimensions = "M-" + (r * .20) + ",0L0," + (r * .08) + "L0,-" + (r * .08) + "Z";

            if (vw <= 500) {
                // w = w - 10;
                chartWidth = w + padding.left;
                chartHolderX = w / 2 + 2;
                arrowX = w - 10;
                arrowDimensions = "M-" + (r * .12) + ",0L0," + (r * .05) + "L0,-" + (r * .05) + "Z";
            }

            let svg = d3.select('#chart')
                .append("svg")
                .data([data])
                // .attr("cx", -15)
                // .attr("viewBox", '0 0 '+vw+' 100')
                .attr("preserveAspectRatio", "xMinYMin meet")
                .attr("width", chartWidth)
                .attr("height", h + padding.top + padding.bottom);
            // .attr("width", '100%')
            // .attr("height", '100%');
            // .attr("width", '500px')
            // .attr("height", '500px');
            // Add the gradient definition to the SVG's <defs> section

            const gradient = svg.append("defs")
              .append("linearGradient")
              .attr("id", "myGradient")  // Unique identifier for the gradient
              .attr("x1", "0%")
              .attr("y1", "0%")
              .attr("x2", "100%")
              .attr("y2", "0%");  // Horizontal gradient (change to adjust direction)

            // Add color stops to the gradient
            gradient.append("stop")
              .attr("offset", "0%")
              .attr("stop-color", wheelOuterColorGrad1);

            gradient.append("stop")
              .attr("offset", "100%")
              .attr("stop-color", wheelOuterColorGrad2);

            let container = svg.append("g")
                .attr("class", "chartholder")
                .attr("id", "container-spin")
                .attr("transform", "translate(" + (chartHolderX - 5) + "," + (h / 2 + padding.top) + ")");
            let vis = container
                .append("g");

            let pie = d3.layout.pie().sort(null).value(function (d) { return 1; });
            // declare an arc generator function
            let arc = d3.svg.arc().outerRadius(r);
            // select paths, use arc generator to draw
            let arcs = vis.selectAll("g.slice")
                .data(pie)
                .enter()
                .append("g")
                .attr("class", "slice");

            arcs.append("path")
                .attr("stroke-width", pieStrokeWidth)
                .attr("stroke", "#FFFFFF")
                .attr("stroke-location", "inside")
                // .attr("fill", function (d, i) { return color(i); })
                .attr("fill", function (d, i) {
                    return data[i].color;
                })
                .attr("d", function (d) { return arc(d); });
            // add the text
            arcs.append("text").attr("transform", function (d) {
                d.innerRadius = 0;
                d.outerRadius = r;
                d.angle = (d.startAngle + d.endAngle) / 2;
                return "rotate(" + (d.angle * 180 / Math.PI - 90) + ")translate(" + (d.outerRadius - wheelTextPadding) + ")";
            })
                .attr("text-anchor", "end")
                .style({
                    "fill": "white",
                    "font-weight": "bold",
                    "font-size": spinWheelTextSize
                })
                .text(function (d, i) {
                    return data[i].name;
                    // return 'Offer just checking here in the new';
                });
            container.on("click", spin);
            //make arrow
            svg.append("g")
                .attr("transform", "translate(" + (arrowX) + "," + ((h / 2) + padding.top) + ")")
                .append("path")
                // for adjusting arrow
                // .attr("d", "M-" + (r * .20) + ",0L0," + (r * .08) + "L0,-" + (r * .08) + "Z")
                .attr("d", arrowDimensions)
                .style({ "fill": arrowColor, "filter": "drop-shadow(0.35rem 0.35rem 0.4rem rgba(0, 0, 0, 0.5))" });

            //draw spin circle
            container.append("circle")
                .attr("cx", 0)
                .attr("cy", 0)
                .attr("r", spinWheelCenterRadius)
                .style({ "fill": "white", "cursor": "pointer",
                  "filter": "drop-shadow(0.25rem 0.25rem 0.4rem rgba(0, 0, 0, 0.5))" });

            if (compData && compData.randomizerConfigs && compData.randomizerConfigs.spinWheelLogo) {
                container.append('image')
                    .attr("x", spinWheelLogoX)
                    .attr("y", spinWheelLogoy)
                    .style({ "width": spinWheelLogoWidth })
                    .attr('xlink:href', compData.randomizerConfigs.spinWheelLogo ? compData.randomizerConfigs.spinWheelLogo.file : '');
                // .attr('xlink:href', 'https://benchvote-assets.s3-ap-southeast-2.amazonaws.com/backgrounds/WGC0998Pint0ClockWests_Logo_600x250px-1685069945597.png')
                // .attr("x", -23)
                // .attr("y", -23)
                // .attr('xlink:href', 'https://admin.campaignware.com/img/favicon.ico')
                // .attr('width', 60)
                // .attr('height', 60)
            }

            //draw border circle
            console.log('radius', r);
            container.append("circle")
                .attr("cx", 0)
                .attr("cy", 0)
                .attr("r", r + borderRadiusExtra)
                .attr("stroke-width", borderStrokeWidth)
                // .attr("stroke", "#f7ba00")
                .attr("stroke", "url(#myGradient)")
                .style({ "fill": "none", "cursor": "pointer",
                  "filter": "drop-shadow(0.15rem 0.15rem 0.4rem rgba(0, 0, 0, 0.5))" });
            //spin text
            // container.append("text")
            //     .attr("x", 0)
            //     .attr("y", 15)
            //     .attr("text-anchor", "middle")
            //     .text("CW")
            //     .style({ "font-weight": "bold", "font-size": "30px" });


            function spin(d) {

                container.on("click", null);
                //all slices have been seen, all done
                console.log("OldPick: " + oldpick.length, "Data length: " + data.length);
                if (oldpick.length == data.length) {
                    console.log("done");
                    container.on("click", null);
                    return;
                }
                let randNum = Math.random();
                let ps = 360 / data.length,
                    pieslice = Math.round(totalRotationAngle / data.length),
                    rng = Math.floor((randNum * totalRotationAngle) + 360);

                console.log('rand', randNum);
                console.log('ps', ps);
                console.log('rng', rng);
                // rotation = rng;
                console.log('rot', rotation);

                // rng = 2304; // for offer 7
                // rng = 360*5.2; // in multiples of 0.2 for 5 offers
                // rng = 360*5.167; // in multiples of 0.17 for 6 offers
                // rng = 360*5.1; // in multiples of 0.1 for 10 offers



                // dynamic selection based on weight
                // var selection = 2; // key
                // var selection = weightedRandom();
                // console.log('selected', selection);
                let selectionMatch = data.length - selection;
                rng = 360 * (wheelSpinSpeed + (1 * selectionMatch / data.length));

                rotation = (Math.round(rng / ps) * ps);

                picked = Math.round(data.length - (rotation % 360) / ps);
                // picked = 2;
                picked = picked >= data.length ? (picked % data.length) : picked;
                console.log('pick', picked);
                if (oldpick.indexOf(picked) !== -1) {
                    d3.select(this).call(spin);
                    return;
                } else {
                    oldpick.push(picked);
                }
                rotation += 90 - Math.round(ps / 2);
                console.log('rot-1', rotation);
                vis.transition()
                    .duration(7000)
                    // .ease("ease-in")
                    .attrTween("transform", rotTween)
                    .each("end", function () {
                        //mark question as seen
                        d3.select(".slice:nth-child(" + (picked + 1) + ") path")
                        // .attr("fill", "#111")
                        // .attr("stroke-width", "4")
                        // .attr("stroke-location", "center")
                        // .attr("stroke", "#111");
                        //populate question
                        d3.select("#question h1")
                            .text(selectedOffer.description);
                        // .text(data[picked].description);

                        let question = document.getElementById("question");

                        if (question) {
                            question.style.display = "block";
                        }

                        // allow-multiple
                        localStorage.setItem(`${compData.id}-offerViewed`, "1");
                        setSessionValidity(compData.id);
                        onSpinComplete();

                        let chart = document.getElementById("chart");

                        setTimeout(() => {
                            if (chart) {
                                chart.style.opacity = "0";
                                chart.style.height = "0";
                                chart.style.transition = "height 8s, visibility 2s, opacity 1s ease-out";
                                chart.style.visibility = "hidden";
                                setTimeout(() => {
                                    chart.style.display = "none";
                                }, 4200);
                            }
                        }, 600);

                        // offerViewed = true;

                        oldrotation = rotation;

                        /* Get the result value from object "data" */
                        console.log(data[picked].value)

                        /* Comment the below line for restrict spin to sngle time */
                        // container.on("click", spin);
                    });
            }

            function rotTween(to) {
                let i = d3.interpolate(oldrotation % 360, rotation);
                return function (t) {
                    return "rotate(" + i(t) + ")";
                };
            }
        },
        [data.length]
    );

    let fadeDuration = 5;

    window.scrollTo(0, 0);

    return (
        <div ref={ref} style={{ width: "100%" }}>
            {/* <svg
                ref={ref}
                style={{
                    height: 500,
                    width: "100%",
                    marginRight: "0px",
                    marginLeft: "0px",
                }}
            >
                <g className="plot-area" />
                <g className="x-axis" />
                <g className="y-axis" />
            </svg> */}
            {/* <Fade
                out={offerViewed}
                duration={fadeDuration}
                style={{
                    visibility: offerViewed ? 'hidden' : 'visible'
                }}
            > */}

            {!offerViewed && compData.logoBg ? (
              <div className={'logos-cont main-logo-cont'}>
                  <img src={compData.logoBg.file} alt={compData.name} className={'logo-image'}
                  style={{maxHeight: '120px'}}/>
              </div>
            ) : null}

            {/* spin wheel */}
            <div id="chart" className={((compData && compData.randomizerConfigs
                && compData.randomizerConfigs.isCustomGif === 1)) ? 'd-none' : null}
                style={{
                    opacity: (offerViewed ? '0' : '1'),
                    height: (offerViewed ? '0' : '65vh'),
                    visibility: (offerViewed ? 'hidden' : 'visible'),
                    transition: (offerViewed ? 'height 1s, visibility 2s, opacity 1s ease-out' : 'none'),
                }}></div>

            {/* custom gif */}
            {compData && compData.randomizerConfigs && compData.randomizerConfigs.isCustomGif === 1
                && compData.randomizerConfigs.spinWheelLogo
                && compData.randomizerConfigs.spinWheelLogo.file ?
                (<div className={'offer-custom-gif'}
                    style={{
                        opacity: (offerViewed ? '0' : '1'),
                        height: (offerViewed ? '0' : 'unset'),
                        visibility: (offerViewed ? 'hidden' : 'visible'),
                        transition: (offerViewed ? 'height 1s, visibility 2s, opacity 1s ease-out' : 'none'),
                    }}
                >
                    {!isVideo(compData.randomizerConfigs.spinWheelLogo.file) ?
                      <img alt='loader-gif' src={compData.randomizerConfigs.spinWheelLogo.file} /> : null}

                    {isVideo(compData.randomizerConfigs.spinWheelLogo.file) ?
                      <div className='suspense-video-block'>
                        <video autoPlay={true} muted={true} loop={false} controls={false} playsInline={true} id='suspense-video'>
                            <source src={compData.randomizerConfigs.spinWheelLogo.file} type="video/mp4"/>
                        </video>
                        <img alt='Mute' id="mute-button" onClick={toggleMute}
                          src='https://benchvote-media-assets.s3.ap-southeast-2.amazonaws.com/assorted/reeses/volume_off.png' />
                      </div> : null}

                </div>) : null}

            {/* <div id="chart"></div> */}
            {/* </Fade> */}
            <div id="question" className='mb-0'
              style={{ display: (offerViewed ? 'block' : 'none'), color: compData.primaryColor }}>


                {/* {REESES_CAMPAIGN.includes(compData.id) ?
                  <div className='recees-offer-text-desk'>
                    <h3>{selectedOffer.description}</h3>
                  </div> : null}*/}

                {selectedOffer && selectedOffer.offerImageUrl && selectedOffer.offerImageUrl != '' ?
                  (<div className={"m-auto w-100"}>
                        <img src={selectedOffer.offerImageUrl} className={'offer-won-image'} alt='Offer' />
                    </div>) : null}

                {!REESES_CAMPAIGN.includes(compData.id) && (!BEIN_CAMPAIGN.includes(compData.id) || selectedOffer.type === 'default_offer')
                   ? <h1 className='offer-text'>{selectedOffer.description}</h1> : null}

                {BEIN_CAMPAIGN.includes(compData.id) && selectedOffer.type !== 'default_offer'
                   ? <p className='offer-text offer-text-sm'>{selectedOffer.description}</p> : null}

                {REESES_CAMPAIGN.includes(compData.id) ?
                  <div>
                    <h3>{selectedOffer.description}</h3>
                    <img src='https://benchvote-media-assets.s3.ap-southeast-2.amazonaws.com/assorted/reeses/reeses-prize-context.png'
                      alt='Dont worry you are still in the running to win tickets to an exclusive screening of Scream 7'/>
                  </div> : null}

                {!BEIN_CAMPAIGN.includes(compData.id) && ((!compData.randomizerConfigs.offerCodeViewType && compData.randomizerConfigs.offerCodeViewType != 0)
                    || compData.randomizerConfigs.offerCodeViewType == 1 && code && code != '') ? (
                    <div className={`offer-code-section ${(offerData && offerData.offer && offerData.offer.type) ? offerData.offer.type : ''}`}>
                        <div className='code-header'>
                            Use this code
                        </div>
                        <div className='code-block'>
                            <div className='code-block-content'>
                                {code}
                            </div>
                        </div>
                    </div>) : null}

                {compData.randomizerConfigs.offerCodeViewType == 2 && code && code != '' ? (
                    <div className={`offer-code-section ${(offerData && offerData.offer && offerData.offer.type) ? offerData.offer.type : ''}`}>
                        <div className='code-header'>
                            Scan this Barcode
                        </div>
                        <div className='bar-code-block'>
                            <div className='bar-code-block-content'>
                                <Barcode value={code} />
                            </div>
                        </div>
                    </div>) : null}

                {compData.randomizerConfigs.offerCodeViewType == 3 && code && code != '' ? (
                    <div className={`offer-code-section ${(offerData && offerData.offer && offerData.offer.type) ? offerData.offer.type : ''}`}>
                        <div className='code-header'>
                            Scan this QR Code
                        </div>
                        <div className='qr-code-block'>
                            {code ?
                                (<QRCode
                                    size={256}
                                    style={{ height: "auto", maxWidth: "100%", width: "50%" }}
                                    value={code}
                                    viewBox={`0 0 256 256`}
                                />) : null}
                        </div>
                    </div>) : null}


                {offerData && offerData.validTill && offerData.validTill != '' && code && code != '' ? (
                    <div className={`offer-validity ${(offerData && offerData.offer && offerData.offer.type) ? offerData.offer.type : ''}`}>
                        {/* Expires: {new Date(`${offerData.validTill} UTC`).toLocaleString()} */}
                        Expires: {new Date(offerData.validTill).toLocaleString()}
                    </div>) : null}

                {compData.randomizerConfigs.isOfflineRedemption && compData.randomizerConfigs.offlineRedemptionText
                    && compData.randomizerConfigs.offlineRedemptionText != ''
                    && offerData && offerData.offer && offerData.offer.type != 'default_offer'
                    && !['Bad Luck', 'Try Again', 'Better Luck Next Time'].includes(offerData.offer.offerName) ?
                    (
                    <div>
                        <div className='offline-block'
                            dangerouslySetInnerHTML={{
                                __html: decodeOtherLanguage(compData.randomizerConfigs.offlineRedemptionText)
                            }}>
                        </div>

                        {offerData && offerData.uniqueRedemptionID != '' ? (
                        <div className='unique-code-block'>
                            <div className='unique-code-block-content'>
                                {offerData.uniqueRedemptionID}
                            </div>
                        </div>) : null}
                    </div>
                ) : null}

            </div>
        </div>

    );
}

export default SpinWheel;
